import React from "react";

/** Two-column key/value tile used across the LeadDetail Overview tab. */
export function InfoTile({ k, v }) {
  return (
    <div className="min-w-0">
      <div className="label-mono">{k}</div>
      <div className="truncate">{v || "—"}</div>
    </div>
  );
}

/** Payload dump card (Original / Normalized / Delivered). */
export function PayloadCard({ title, v }) {
  return (
    <div className="border border-black">
      <div className="bg-black text-white px-2 py-1 uppercase text-[10px] tracking-widest">{title}</div>
      <pre className="p-2 whitespace-pre-wrap max-h-[300px] overflow-auto">
        {v ? JSON.stringify(v, null, 2) : "—"}
      </pre>
    </div>
  );
}
